/**
 * Small footer note for competitor comparison / "alternative" pages.
 *
 * Naming a competitor to compare against them is nominative fair use, but we
 * make the "no affiliation" stance explicit so the pages can't be read as
 * implying endorsement. `names` is a human-readable list of the third-party
 * products referenced on the page (e.g. "Instapaper").
 */
const TrademarkDisclaimer = ({ names }) => (
  <section className="py-4">
    <div className="container">
      <div className="col-lg-10 mx-auto">
        <p className="text-muted small text-center mb-0">
          {names} and all related names, logos, and trademarks are the property
          of their respective owners. onBookmarks is not affiliated with,
          endorsed by, or sponsored by them. Comparisons reflect our
          understanding of publicly available information and may change over
          time.
        </p>
      </div>
    </div>
  </section>
);

export default TrademarkDisclaimer;
